'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _actions = require('../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _facets = require('../components/facets');

var _facets2 = _interopRequireDefault(_facets);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Common');

var FacetsContainer = (_temp2 = _class = function (_React$Component) {
    (0, _inherits3.default)(FacetsContainer, _React$Component);

    function FacetsContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FacetsContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FacetsContainer.__proto__ || (0, _getPrototypeOf2.default)(FacetsContainer)).call.apply(_ref, [this].concat(args))), _this), _this.clearChecked = function () {
            window.location.assign(window.location.origin + window.location.pathname);
        }, _this.facetBack = function () {
            _this.props.back();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FacetsContainer, [{
        key: 'render',
        value: function render() {
            var groups = this.props.groups || [];
            var facetHistory = this.props.facetHistory || [];

            return _react2.default.createElement(
                'div',
                { className: 'facets__wrap' },
                _react2.default.createElement(_facets2.default, { groups: groups, onChange: this.props.change }),
                _react2.default.createElement(
                    'div',
                    { className: 'facet-clear' },
                    _react2.default.createElement(
                        'a',
                        { id: 'clearChecked', onClick: this.clearChecked },
                        Resx.Common.Clear
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'a',
                        { id: 'facetBack', onClick: this.facetBack,
                            className: facetHistory.length === 0 ? 'hidden' : 'prdel' },
                        Resx.Common.Back
                    )
                )
            );
        }
    }]);
    return FacetsContainer;
}(_react2.default.Component), _class.propTypes = {
    groups: _react2.default.PropTypes.array.isRequired,
    change: _react2.default.PropTypes.func.isRequired,
    clearChecked: _react2.default.PropTypes.func.isRequired,
    back: _react2.default.PropTypes.func.isRequired,
    facetHistory: _react2.default.PropTypes.array.isRequired
}, _temp2);


function mapStateToProps(state, ownProps) {
    return {
        groups: state.facets.groups.length > 0 ? state.facets.groups : ownProps.groups || [],
        facetHistory: state.facets.history
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    change: _actions2.default.change,
    clearChecked: _actions2.default.clearChecked,
    back: _actions2.default.back
})(FacetsContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/containers/facets.js
// module id = 918
// module chunks = 0